import { VFC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Layout } from '../../components/Layout/Layout';
import { MeterIdentificationContent } from './components/Content';
import { MeterIdentificationFooter } from './components/Footer';
import { MeterIdentificationPage as messages } from './messages';

export const MeterIdentificationPage: VFC = () => (
  <Layout
    footerContent={<MeterIdentificationFooter />}
    headerContent={<FormattedMessage {...messages.meterIdentification} />}
  >
    <MeterIdentificationContent />
  </Layout>
);
